import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import { LazyImage } from "react-lazy-images";
import { sendMetriks } from "Services/sendMetriks";
import { AntifilterHeaderGif } from "Constants/url";
import { getSocialNetworksTexts } from "Helpers/localeText";
import RatesmobileConnectButton from "Containers/Buttons/RatesmobileConnectButton";
import { UnlimitedSocial } from "designSystem/UnlimetedSocial";
import { RangePickerAntifilter } from "ComponentsUI/Rangepicker";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		marginBottom: "40px",
		textAlign: "center",
	},
	header: {
		width: "280px",
		display: "flex",
		alignItems: "center",
	},
	headerMargin: {
		margin: "0px 0px 20px 0px",
	},
	choose: {
		width: "185px",
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1.9,
		letterSpacing: 1.8,
	},
	chooseGif: {
		fontSize: "12px",
	},
	text: {
		width: "280px",
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		color: theme.palette.colors.oneMoreGrey,
		margin: "0px 0px 20px 0px",
		textAlign: "start",
	},
	gifContainer: {
		height: "280px",
		margin: "20px 0",
	},
	gif: {
		height: "280px",
	},
	antiBox: {
		width: "280px",
		height: "auto",
		border: `2px solid ${theme.palette.colors.purplishBlue}`,
		borderRadius: "15px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		backgroundColor: theme.palette.colors.white,
	},
	textTariff: {
		width: "280px",
		fontFamily: theme.fonts.medium,
		fontSize: "18px",
		color: theme.palette.colors.purplishBlue,
		textAlign: "center",
		padding: "0px 10px 10px 10px",
		marginTop: "25px",
		"& $br": {
			display: "none",
		},
	},
	socialData: {
		width: "280px",
		padding: "10px 10px 0",
	},
	BoxBlockChoice: {
		margin: "10px",
		width: "auto",
		height: "50px",
		display: "flex",
		flexDirection: "row",
		justifyContent: "center",
		alignItems: "center",
	},
	BoxBlock: {
		width: "auto",
		height: "110px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
	ButtonSelection: {
		width: "25px",
		height: "25px",
		textAlign: "center",
		margin: "0px 5px",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		alignContent: "center",
		backgroundColor: theme.palette.colors.white,
	},
	checkbox: {
		width: "25px",
		height: "25px",
		color: theme.palette.colors.purplishBlue,
		border: `1px solid ${theme.palette.colors.oneMoreGrey}`,
		fontFamily: theme.fonts.medium,
		marginRight: "10px",
	},
	checkbox_active: {
		background: theme.palette.colors.purplishBlue,
		width: "25px",
		height: "25px",
		border: `3px solid ${theme.palette.colors.purplishBlue}`,
		"& span": {
			display: "block",
			color: theme.palette.colors.white,
		},
	},
	text_curent: {
		color: theme.palette.colors.oneMoreGrey,
	},
	text_active: {
		color: theme.palette.colors.purplishBlue,
	},

	ContentBoxBlock: {
		width: "140px",
		height: "50px",
		margin: "0px 10px 0px 10px",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	ContentBoxBlockText: {
		fontFamily: theme.fonts.medium,
		fontSize: "30px",
		color: theme.palette.colors.darkSlateBlue2,
		textAlign: "center",
	},

	ContentBoxBlockTextDescription: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
		color: theme.palette.colors.darkSlateBlue2,
		textAlign: "center",
		marginLeft: "5px",
	},

	ColorDarkSlateBlue: {
		color: theme.palette.colors.darkSlateBlue2,
	},

	ColorPurplishBlue: {
		color: theme.palette.colors.purplishBlue,
	},

	img: {
		maxWidth: "100%",
		maxHeight: "50px",
	},
	CheckboxBox: {
		display: "flex",
		fleDirection: "row",
		alignItems: "center",
	},
	CheckboxText: {
		fontFamily: theme.fonts.medium,
		fontSize: "14px",
	},
	enabled: {
		color: theme.palette.colors.purplishBlue,
	},
	disable: {
		color: theme.palette.colors.oneMoreGrey,
	},
	iconArrow: {
		paddingLeft: "5px",
		fontSize: "14px",
		fontWeight: "bold",
		color: theme.palette.colors.purplishBlue,
	},
	clickable: {
		cursor: "pointer",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {},
	[`@media (max-width: ${theme.media.sm})`]: {},
}));

const ButtonSelection = (props) => {
	const classes = useStyles();
	let { text, onClick, enabled } = props;
	const enabledStyle = enabled || enabled === "0";
	const classNameButton = classNames(classes.ButtonSelection, {
		[classes.enabled]: enabledStyle,
		[classes.disable]: !enabledStyle,
	});
	//
	return (
		<div onClick={onClick} disabled={!enabled} className={classNameButton}>
			{text === "+" && (
				<img
					src={require(
						enabled ? "icons/anti_filter/plus_enabled.svg" : "icons/anti_filter/plus_disable.svg"
					)}
					alt="ShowPopup-1"
				/>
			)}

			{text === "-" && (
				<img
					src={require(
						enabled ? "icons/anti_filter/minus_enabled.svg" : "icons/anti_filter/minus_disable.svg"
					)}
					alt="ShowPopup-1"
				/>
			)}

			{text === "<" && (
				<img
					src={require(
						enabled
							? "icons/anti_filter/left_arrow_enabled.svg"
							: "icons/anti_filter/left_arrow_disable.svg"
					)}
					alt="ShowPopup-1"
				/>
			)}

			{text === ">" && (
				<img
					src={require(
						enabled
							? "icons/anti_filter/right_arrow_enabled.svg"
							: "icons/anti_filter/right_arrow_disable.svg"
					)}
					alt="ShowPopup-1"
				/>
			)}
		</div>
	);
};
const ButtonCheckbox = (props) => {
	let { text, checked, onClickSetChecked } = props;
	const classes = useStyles();

	const className = classNames(classes.checkbox, {
		[classes.checkbox_active]: checked,
	});

	const classNameText = classNames(classes.CheckboxText, {
		[classes.text_active]: checked,
		[classes.text_curent]: !checked,
	});

	return (
		<>
			<label>
				<div
					type="checkbox"
					onClick={() => {
						onClickSetChecked();
					}}
					className={className}
				>
					{checked && <span className="icon24 icon-check" />}
				</div>
			</label>
			<div className={classNameText}>{checked ? text.fixed : text.fix}</div>
		</>
	);
};

const DodyAccordionList = (props) => {
	const classes = useStyles();

	let { text, textInfo, headerAntifilterMode } = props;

	if (headerAntifilterMode == "off") {
		return null;
	}

	const [dodies, setDodies] = useState(headerAntifilterMode === "gif");

	if (dodies) sendMetriks("CLICK_INSTRUCTION");

	const classNameHeader = classNames(classes.header, {
		[classes.headerMargin]: !dodies,
	});

	return (
		<>
			<div className={classNameHeader}>
				<div
					onClick={() => setDodies((prev) => !prev)}
					className={classNames(classes.choose, {
						[classes.chooseGif]: headerAntifilterMode === "gif",
					})}
				>
					{text.HOW_IT_WORKS}
				</div>
				<span
					onClick={() => setDodies((prev) => !prev)}
					className={classNames(
						dodies ? "icon24 icon-arrow-1-up" : "icon24 icon-arrow-1-down",
						classes.iconArrow,
						classes.clickable
					)}
				/>
			</div>
			{dodies &&
				(headerAntifilterMode == "gif" ? (
					<div className={classes.gifContainer}>
						<LazyImage
							src={AntifilterHeaderGif}
							placeholder={({ imageProps, ref }) => <img ref={ref} className={classes.gif} />}
							actual={({ imageProps }) => (
								<img
									{...imageProps}
									alt={text.HOW_IT_WORKS}
									className={classes.gif}
									onClick={() => setDodies((prev) => !prev)}
								/>
							)}
						/>
					</div>
				) : (
					<div
						className={classes.text}
						dangerouslySetInnerHTML={{
							__html: textInfo,
						}}
					/>
				))}
		</>
	);
};

const FilterBlock = (props) => {
	const classes = useStyles();
	let {
		text,
		type,
		logoOperator,
		textLogo,
		description,
		bntType,
		arrData,
		setState,
		setSwitchTariff,
		switchType,
		checked,
		setChecked,
		arrRange,
		isLoading,
	} = props;

	const [openRange, SetOpenRange] = useState(false);

	const onClickSetChecked = () => {
		setState(arrData[1]);
		setChecked(!checked);
		setSwitchTariff("id");
		sendMetriks("CHANGE_ANTIFILTR");
	};

	const onClickNext = () => {
		if (arrData[2]) {
			setState(arrData[2]);
			setSwitchTariff(switchType);
			sendMetriks("CHANGE_ANTIFILTR");
		}
	};

	const onClickPrevious = () => {
		if (arrData[0] || arrData[0] == 0) {
			setState(arrData[0]);
			setSwitchTariff(switchType);
			sendMetriks("CHANGE_ANTIFILTR");
		}
	};
	return (
		<div className={classes.BoxBlock}>
			{openRange ? (
				<RangePickerAntifilter
					setStateRange={SetOpenRange}
					arrRange={arrRange}
					setStateValue={setState}
					switchType={switchType}
					setSwitchTariff={setSwitchTariff}
					valueCur={arrData[0]}
					description={description}
				/>
			) : (
				<>
					<div className={classes.BoxBlockChoice}>
						<ButtonSelection
							onClick={onClickPrevious}
							text={bntType === "arrows" ? "<" : "-"}
							enabled={(arrData?.[0] || arrData[0] === 0) && !isLoading}
						/>
						{type === "img" ? (
							<div className={classes.ContentBoxBlock}>
								<LazyImage
									src={logoOperator}
									placeholder={({ ref }) => <img ref={ref} />}
									actual={({ imageProps }) => (
										<img
											{...imageProps}
											className={classes.img}
											alt={"Фото оператора для антифильтра"}
										/>
									)}
								/>
							</div>
						) : (
							<div onClick={() => SetOpenRange(true)} className={classes.ContentBoxBlock}>
								<div
									className={classNames(classes.ContentBoxBlockText, {
										[classes.ColorPurplishBlue]: switchType === "price",
										[classes.ColorDarkSlateBlue]: switchType !== "price",
									})}
								>
									{textLogo}
								</div>
								<div
									className={classNames(classes.ContentBoxBlockTextDescription, {
										[classes.ColorPurplishBlue]: switchType === "price",
										[classes.ColorDarkSlateBlue]: switchType !== "price",
									})}
								>
									{description}
								</div>
							</div>
						)}
						<ButtonSelection
							onClick={onClickNext}
							text={bntType === "arrows" ? ">" : "+"}
							enabled={arrData?.[2] && !isLoading}
						/>
					</div>
					<div className={classes.CheckboxBox}>
						<ButtonCheckbox checked={checked} onClickSetChecked={onClickSetChecked} text={text} />
					</div>
				</>
			)}
		</div>
	);
};

const Btn = (props) => {
	let {
		tariff,
		actions,
		ApplicationModel: {
			modalModel,
			siteConfig: {
				settings: { frame_esim_mts: frameEsimMtsSettings = 0 },
			},
		},
	} = props;
	const closeModal = () => {
		if (modalModel.isOpenMtsConnect) {
			sendMetriks("CLOSE_ESIM_MTS");
			modalModel.toggleModalMtsConnect();
		}
	};

	let cbo = tariff?.provider?.operator_settings?.tariffs?.value;

	const haveEsim =
		tariff?.mobile_new?.tag_mobil?.some(({ translit }) => translit === "esim") || false;

	const onClickHandler = async (globalId, actions) => {
		if (actions) {
			sendMetriks("CLICK_CONNECT_ACTION");
		}
		if (globalId == 1874) {
			sendMetriks("CLICK_CONNECT_TINKOFF_FROM_RATESMOBILE");
		}
		if (globalId == 1876) {
			sendMetriks("CLICK_CONNECT_BEELINE_FROM_RATESMOBILE");
		}
		if (globalId == 1880) {
			sendMetriks("CLICK_CONNECT_MEGAFON_FROM_RATESMOBILE");
		}
		if (globalId == 1879) {
			sendMetriks("CLICK_CONNECT_TELE2_FROM_RATESMOBILE");
		}
		if (globalId == 1878) {
			sendMetriks("CLICK_CONNECT_YOTA_FROM_RATESMOBILE");
		}
		if (globalId == 1873) {
			sendMetriks("CLICK_CONNECT_SBER_FROM_RATESMOBILE");
		}
		if (globalId == 1877) {
			sendMetriks("CLICK_CONNECT_MTC_FROM_RATESMOBILE");
		}
		sendMetriks("CLICK_CONNECT_OPERATORY");

		if (frameEsimMtsSettings && haveEsim && globalId === 1877 && cbo !== "popup") {
			closeModal();
			sendMetriks("CLICK_CONNECT_ESIM_MTS");
			let promise1 = import("Layouts/modalLayout");
			let promise2 = import("ComponentsUI/Iframes/MtsConnect");
			Promise.all([promise1, promise2]).then((modules) => {
				let ModalLayout = modules[0].default;
				let MtsConnect = modules[1].default;

				modalModel.toggleModalMtsConnect(
					<ModalLayout closeModal={() => closeModal()}>
						<MtsConnect />
					</ModalLayout>
				);
			});
		}
	};
	let buttons = (
		<RatesmobileConnectButton
			tariff={tariff}
			onClickHandler={onClickHandler}
			antifilter={true}
			actions={actions}
		/>
	);

	return buttons;
};

const FilterAntiFilter = (props) => {
	let {
		ApplicationModel,
		text,
		arrCallsButton,
		arrInternetButton,
		arrPriceButton,
		arrOperotorsButton,
		setProviderId,
		providerId,
		setPriceTariff,
		priceTariff,
		setCallsTariff,
		setInternetTariff,
		setSwitchTariff,
		logoOperator,
		internet,
		calls,
		price,
		fixProvider,
		setFixProvider,
		fixPrice,
		setFixPrice,
		fixCalls,
		setFixCalls,
		fixInternet,
		setFixInternet,
		tariff,
		arrCalls,
		arrPrice,
		arrInternet,
		isLoading,
		headerAntifilterMode,
		actions,
	} = props;
	const classes = useStyles();
	const socialNetworksTexts = getSocialNetworksTexts(text);

	const socialData =
		props.socialData &&
		Object.entries(props.socialData)
			.filter(([, value]) => value === 1)
			.map(([key]) => ({
				key,
				tooltipText: socialNetworksTexts[key],
			}));

	return (
		<div className={classes.root}>
			<DodyAccordionList
				textInfo={props.textInfo}
				text={text}
				headerAntifilterMode={headerAntifilterMode}
			/>
			<div className={classes.antiBox}>
				<div
					className={classes.textTariff}
					dangerouslySetInnerHTML={{
						__html: props.nameTariff,
					}}
				></div>
				<FilterBlock
					text={text}
					type={"img"}
					logoOperator={logoOperator}
					bntType={"arrows"}
					arrData={arrOperotorsButton}
					setState={setProviderId}
					setSwitchTariff={setSwitchTariff}
					switchType={"provider"}
					state={providerId}
					checked={fixProvider}
					setChecked={setFixProvider}
					isLoading={isLoading}
				/>
				<FilterBlock
					text={text}
					textLogo={internet}
					description={"гб"}
					arrData={arrInternetButton}
					setState={setInternetTariff}
					setSwitchTariff={setSwitchTariff}
					switchType={"internet"}
					checked={fixInternet}
					setChecked={setFixInternet}
					arrRange={arrInternet}
					isLoading={isLoading}
				/>
				<FilterBlock
					arrData={arrCallsButton}
					setState={setCallsTariff}
					text={text}
					textLogo={calls}
					description={"мин"}
					setSwitchTariff={setSwitchTariff}
					switchType={"calls"}
					checked={fixCalls}
					setChecked={setFixCalls}
					arrRange={arrCalls}
					isLoading={isLoading}
				/>
				<FilterBlock
					text={text}
					textLogo={price}
					arrData={arrPriceButton}
					description={"руб/мес"}
					setState={setPriceTariff}
					setSwitchTariff={setSwitchTariff}
					switchType={"price"}
					checked={fixPrice}
					setChecked={setFixPrice}
					state={priceTariff}
					arrRange={arrPrice}
					isLoading={isLoading}
				/>
				{Boolean(socialData?.length) && (
					<div className={classes.socialData}>
						<UnlimitedSocial header={text.unlim_na} socialData={socialData} antifilter={true} />
					</div>
				)}
				<Btn ApplicationModel={ApplicationModel} text={text} tariff={tariff} actions={actions} />
			</div>
		</div>
	);
};
export default FilterAntiFilter;
